export const translations = {
  es: {
    heroTitle: "Automatiza la atención de tu negocio con IA",
    heroSubtitle:
      "PulseChatbot responde a tus clientes 24/7 por WhatsApp y web, sin perder ventas ni tiempo.",
    cta: "Solicitar demo gratis",

    featuresTitle: "¿Qué hace PulseChatbot?",
    feature1Title: "Respuestas automáticas",
    feature1Desc:
      "Atiende preguntas frecuentes al instante, sin intervención humana.",
    feature2Title: "Atención 24/7",
    feature2Desc:
      "Tu negocio sigue respondiendo incluso fuera de horario.",
    feature3Title: "Más ventas",
    feature3Desc:
      "No pierdas clientes por mensajes sin responder.",

    businessTitle: "Ideal para tu negocio",

    integrationsTitle: "Integraciones",
    integrationsDesc:
      "PulseChatbot se integra con las plataformas que tus clientes ya usan.",
    whatsappTitle: "WhatsApp",
    whatsappDesc:
      "Automatiza mensajes, pedidos y reservas directamente desde WhatsApp.",
  },

  en: {
    heroTitle: "Automate your business customer support with AI",
    heroSubtitle:
      "PulseChatbot responds to your customers 24/7 via WhatsApp and web without losing sales.",
    cta: "Request free demo",

    featuresTitle: "What does PulseChatbot do?",
    feature1Title: "Automated replies",
    feature1Desc:
      "Instantly answer frequent questions with no human intervention.",
    feature2Title: "24/7 support",
    feature2Desc:
      "Your business keeps responding even outside business hours.",
    feature3Title: "More sales",
    feature3Desc:
      "Never lose customers due to unanswered messages.",

    businessTitle: "Perfect for your business",

    integrationsTitle: "Integrations",
    integrationsDesc:
      "PulseChatbot integrates with the platforms your customers already use.",
    whatsappTitle: "WhatsApp",
    whatsappDesc:
      "Automate messages, orders and reservations directly from WhatsApp.",
  },
};
